// adminApi.js
import axios from 'axios';

const   CONTACT_API_SERVICE = `${process.env.REACT_APP_API_URL}/adminservice/api/contact`;

const apiClient = axios.create({
    baseURL: CONTACT_API_SERVICE,
    withCredentials: true,
});

const contact = {

    getContactMessages:() =>
        apiClient.get("/allMessages"),
    
};

export default contact;
